<template>
  <div class="container" :ref="`echart-${_uid}`" :id="`echart-${_uid}`">
  </div>
</template>
<script>
import echarts from 'echarts'

export default {
  name: '',
  components: {},
  props: {
    title: {
      type: String
    },
    foodList: {
      type: Array,
      default () {
        return []
      }
    },
    color: {
      type: String,
      default: '#3398DB'
    }
  },
  data () {
    return {
      echart: null
    }
  },
  mounted () {
    this.drawLine()
    let self = this

    window.onresize = () => {
      console.log(self)
      self.echart.resize && this.echart.resize()
    }
  },
  methods: {
    drawLine () {
      let chartWrapper = this.$refs[`echart-${this._uid}`]
      this.echart = echarts.init(chartWrapper)
      // console.log(this[`${name}option`])
      console.log(chartWrapper)
      this.echart.setOption(this.echartsOption)
    }
  },
  computed: {
    echartsOption () {
      let xDatas = []
      let yDatas = []
      let self = this
      this.foodList.forEach(food => {
        xDatas.push(food.name)
        yDatas.push(food.num)
      })
      return {
        title: {
          text: this.title
        },
        color: this.color,
        tooltip: {
          trigger: 'axis',
          formatter (params) {
            let image = self.foodList[params[0].dataIndex]
              ? self.foodList[params[0].dataIndex].image
              : 'http://eatery.oss-cn-hangzhou.aliyuncs.com/330441894053393762.jpg'
            let price = self.foodList[params[0].dataIndex]
              ? self.foodList[params[0].dataIndex].singlePrice
              : 0
            let res = `菜名: ${
              params[0].name
            } <br/> 单价: ${price} <br/> 数量: ${
              params[0].value
            } <br/> 例图: <img src="${image}" alt="" width="30" height="30">`
            return res
          },
          textStyle: { color: '#ffff', align: 'left', fontSize: 18 }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: [...xDatas],
            // data: ['1', '2', '3', '4', '5', '6'],
            axisTick: {
              alignWithLabel: true
            },
            axisLabel: {
              interval: 0,
              rotate: -10
            }
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            type: 'bar',
            data: yDatas,
            // data: [60, 70, 60, 30, 20, 10],
            barWidth: '50%'
          }
        ]
      }
    }
  },
  watch: {
    foodList: {
      handler () {
        this.drawLine()
      },
      deep: true
    }
  }
}
</script>
<style lang="scss" scoped>
  .container {
    width: 100%;
    height: 100%;
  }
</style>
